"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackParcelPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var map_1 = __importDefault(require("../../../console/pages/lastMileFast/components/map"));
var get_trip_by_parcel_thunk_1 = require("../../../../reducers/slices/trips/thunks/get_trip_by_parcel_thunk");
var constants_1 = require("../../../console/pages/lastMileFast/components/constants");
var get_user_thunk_1 = require("../../../../reducers/slices/customers/thunks/get_user_thunk");
var animate_maker_1 = require("../../../console/pages/lastMileFast/components/animate_maker");
var sockets_1 = require("../../../../helpers/sockets");
var Route_32px_by_32px_png_1 = __importDefault(require("../../../../assets/icons/Route_32px_by_32px.png"));
var get_parcel_thunk_1 = require("../../../../reducers/slices/parcels/thunks/get_parcel_thunk");
var queryParams_1 = require("../../../../helpers/routing/queryParams");
var TrackParcelPage = function () {
    var _a, _b, _c, _d, _e;
    var markerRef = (0, react_1.useRef)(null);
    var mapRef = react_1.default.useRef(null);
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var parcel_id = (0, react_router_dom_1.useParams)().parcel_id;
    var _f = (0, react_1.useState)([]), polylinePath = _f[0], setPolylinePath = _f[1];
    var _g = (0, react_redux_1.useSelector)(function (state) { return state.tripState; }), loading = _g.loading, trip = _g.trip;
    var parcel = (0, react_redux_1.useSelector)(function (state) { return state.parcelState; }).parcel;
    var _h = (0, react_redux_1.useSelector)(function (state) { return state.customerState; }), isLoadingCustomer = _h.isLoadingCustomer, customer = _h.customer;
    var query = (0, queryParams_1.useQueryParams)();
    var showMapOnly = (_a = query.get("showMapOnly")) !== null && _a !== void 0 ? _a : "false";
    (0, react_1.useEffect)(function () {
        dispatch((0, get_parcel_thunk_1.get_parcel_thunk)({
            _id: parcel_id,
        }));
        dispatch((0, get_trip_by_parcel_thunk_1.get_trip_by_parcel_thunk)({
            parcel_id: parcel_id,
        }));
    }, []);
    (0, react_1.useEffect)(function () {
        drawMapPolyline();
    }, [parcel]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (trip === null || trip === void 0 ? void 0 : trip.driver_id) {
            dispatch((0, get_user_thunk_1.get_user_thunk)({ _id: trip === null || trip === void 0 ? void 0 : trip.driver_id }));
            if (trip === null || trip === void 0 ? void 0 : trip._id) {
                var vehicle = trip === null || trip === void 0 ? void 0 : trip.driver_vehicle_pairing;
                var socketData = [
                    {
                        url: process.env.LETS_TRADE_TRACKING_URL,
                        eventName: "vehicle_location_changed",
                        callback: function (data) {
                            console.log("bike data", data);
                            var cod = {
                                lat: parseFloat(data.lat),
                                lng: parseFloat(data.lng),
                            };
                            setTimeout(function () {
                                mapRef.current.setCenter(cod);
                            }, 5000);
                            (0, animate_maker_1.animateMarkerTo)(markerRef.current.marker, cod);
                        },
                    },
                ];
                var socketService_1 = new sockets_1.SocketService(socketData, process.env.LETS_TRADE_ROOT_TOKEN);
                socketService_1.startListening();
                socketService_1.emitEvent("joinVehicleIdPipe", (_a = vehicle === null || vehicle === void 0 ? void 0 : vehicle.vehicle) === null || _a === void 0 ? void 0 : _a.iccid);
                return function () {
                    socketService_1.stopListening();
                    socketService_1.close();
                };
            }
        }
    }, [trip]);
    var distance = function (parcel) {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _a === void 0 ? void 0 : _a.lat) && ((_b = parcel === null || parcel === void 0 ? void 0 : parcel.collection_address) === null || _b === void 0 ? void 0 : _b.lat)) {
            var ds = doshx_controls_web_1.Utilities.calculateDistanceCrow({
                coordinates1: {
                    lat: parseFloat((_c = parcel === null || parcel === void 0 ? void 0 : parcel.collection_address) === null || _c === void 0 ? void 0 : _c.lat),
                    lng: parseFloat((_d = parcel === null || parcel === void 0 ? void 0 : parcel.collection_address) === null || _d === void 0 ? void 0 : _d.lon),
                },
                coordinates2: {
                    lat: parseFloat((_e = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _e === void 0 ? void 0 : _e.lat),
                    lng: parseFloat((_f = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _f === void 0 ? void 0 : _f.lon),
                },
            });
            if (ds)
                return ds.toFixed(2);
        }
        return 0;
    };
    var statusSelector = [
        {
            status: constants_1.PARCEL_STATUSES.delivered,
            icon: pro_light_svg_icons_1.faHome,
            text: "Arrived",
        },
        {
            status: constants_1.PARCEL_STATUSES.collectedByDriver,
            icon: pro_light_svg_icons_1.faMotorcycle,
            text: "On the way to you",
        },
        {
            status: constants_1.PARCEL_STATUSES.accepted,
            icon: pro_light_svg_icons_1.faBoxes,
            text: "Order Accepted",
        },
    ];
    var formatNumber = function () {
        var number = customer === null || customer === void 0 ? void 0 : customer.cell_number;
        var countryCode = customer === null || customer === void 0 ? void 0 : customer.cell_country_code;
        if (number) {
            if (number.charAt(0) == 0) {
                number = number.slice(1);
            }
            return "".concat(countryCode).concat(number);
        }
        return "";
    };
    var drawMapPolyline = function () {
        var _a, _b, _c, _d, _e, _f;
        var path = [];
        if (parcel) {
            if (((_a = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _a === void 0 ? void 0 : _a.lat) && ((_b = parcel === null || parcel === void 0 ? void 0 : parcel.collection_address) === null || _b === void 0 ? void 0 : _b.lat)) {
                path.push({
                    lat: parseFloat((_c = parcel === null || parcel === void 0 ? void 0 : parcel.collection_address) === null || _c === void 0 ? void 0 : _c.lat),
                    lng: parseFloat((_d = parcel === null || parcel === void 0 ? void 0 : parcel.collection_address) === null || _d === void 0 ? void 0 : _d.lon),
                });
                path.push({
                    lat: parseFloat((_e = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _e === void 0 ? void 0 : _e.lat),
                    lng: parseFloat((_f = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _f === void 0 ? void 0 : _f.lon),
                });
            }
            console.log("path ====>", path);
            setPolylinePath(path);
        }
    };
    var center = polylinePath.length > 0
        ? polylinePath[1]
        : {
            lat: -26.2142883,
            lng: 27.6841737,
        };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "p-4 h-full" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex-1 ".concat(showMapOnly == "false" ? "" : "h-full") }, { children: (0, jsx_runtime_1.jsx)(map_1.default, { containerStyle: { width: "100%", height: showMapOnly == "false" ? "400px" : "100%" }, mapRef: mapRef, path: polylinePath, marker: {
                        markerRef: (trip === null || trip === void 0 ? void 0 : trip._id) ? markerRef : null,
                        position: center,
                        node: "",
                        icon: Route_32px_by_32px_png_1.default,
                    }, center: center, zoom: 20, markers: [] }) })), showMapOnly == "false" && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4 lg:grid lg:grid-cols-2 mt-8" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4 p-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between" }, { children: [((_b = trip === null || trip === void 0 ? void 0 : trip.driver_vehicle_pairing) === null || _b === void 0 ? void 0 : _b.vehicle_registration) && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "flex items-center space-x-6" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "".concat(trip === null || trip === void 0 ? void 0 : trip.driver_name, " ").concat(trip === null || trip === void 0 ? void 0 : trip.driver_surname), bold: true, textColor: "text-black" }) }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-sm" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Vehicle - ".concat((_c = trip === null || trip === void 0 ? void 0 : trip.driver_vehicle_pairing) === null || _c === void 0 ? void 0 : _c.vehicle_registration) }) }))] })) }))), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faPhone, backgroundColor: "bg-white", borderColor: "border-black", iconColor: "text-black", 
                                                // size="xsmall"
                                                loading: false, onClick: function () {
                                                    window.open("tel:".concat(formatNumber()), "_blank");
                                                } }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { icon: pro_light_svg_icons_1.faSms, backgroundColor: "bg-white", borderColor: "border-black", iconColor: "text-black", 
                                                // size="xsmall"
                                                loading: false, onClick: function () {
                                                    window.open("https://wa.me/".concat(formatNumber()), "_blank");
                                                } })] }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-between" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Timeline", bold: true, textColor: "text-black" }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-2 mt-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-2" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "text-black relative top-[1px]" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faClock }) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: ((_d = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _d === void 0 ? void 0 : _d.scheduled_time) ? doshx_controls_web_1.Utilities.formatDateTime((_e = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _e === void 0 ? void 0 : _e.scheduled_time) : "", bold: true, textColor: "text-black" })] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-sm" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Estimated Arrival" }) }))] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-2" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "text-black relative top-[1px]" }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faMapMarker }) })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "".concat(distance(parcel), " km"), bold: true, textColor: "text-black" })] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "text-sm" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "Distance" }) }))] }))] })), (0, jsx_runtime_1.jsx)("hr", { className: "border-black h-1 bg-black" })] }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "p-4 flex flex-col gap-8" }, { children: statusSelector.map(function (x, index) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex gap-4" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.IconButtonControl, { icon: x.icon, backgroundColor: "bg-borders", borderColor: "border-borders", iconColor: (parcel === null || parcel === void 0 ? void 0 : parcel.status) === x.status ? "text-black" : "text-slate-400", size: "large", loading: false, onClick: function () { } }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "relative top-3.5" }, { children: (parcel === null || parcel === void 0 ? void 0 : parcel.status) === x.status ? (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: x.text, bold: true, textColor: "text-black" }) : (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: x.text }) }))] }), index)); }) }))] })))] })));
};
exports.TrackParcelPage = TrackParcelPage;
